import {getBarLength} from 'utils/getBarLength';
import {shouldMask} from 'pattern/groups/stepGroups.js';
import {PALETTE_COLORS} from 'constants/palette-colors.js';
import Colors from 'Colors.js';
const colors = new Colors();

export const getStepClassAndStyle = (props, isSelected, isSelection, color, stepData) => {
    let style = {};
    var className = 'step ';
    let brightness = '';

    if (stepData.group) {
        color = colors.getColorForHash(stepData.group.id);
    }
 
    if (props.on) {
        className += 'on ';
        style['backgroundColor'] = color;

        if (!props.showParameters) {
            if (props.velocity !== 0 && !props.velocity) {
                style.opacity = 1;
            } else {
                let scaled = (props.velocity) * (0.7) + 0.3;
                style.opacity = scaled;
            }
        }
    } else {
        className += 'off ';
    }

    if (props.isAlternateColor) {
        className += ' alternate ';
    }

    if (isSelected) {
        className += ' selected ';
        style.borderColor = color;
        style.backgroundColor = colors.brighten(color, 0.4);
    } else if (props.isCurrentStep && props.isCursor) {
        className += ' cursor ';
    } else if (props.isCurrentStep) {
        className += ' current-step ';
    } else if (props.isCursor) {
        className += ' cursor ';
    } else { 
    }

    if (props.viMode) {
        className += ' vi-mode';
    }

    if (props.on && !isSelected) {
        if (stepData.trackData && stepData.palette !== undefined && stepData.palette !== null) {
            style.borderBottomColor = PALETTE_COLORS[stepData.palette];
            style.borderBottomWidth = '5px';
        } else if (stepData.slice !== 0) {
            style.borderBottomColor = colors.getColor(stepData.slice);
            style.borderBottomWidth = '5px';
            style.borderBottomStyle = 'solid';
        }
    } 

    if (stepData.pLockedParameters.length > 0) {
        className += " p-locked";
    }

    if (!props.showParameters) {
        className += ' not-expanded';
    }


    className += isSelection ? ' selection ' : '';

    let barLength = getBarLength(props.resolution);
    if (barLength > 2 && props.stepNumber % barLength === 0) {
        className += ' beat-division';
    }

    let containerClassName = "step-container";
    if (isSelection) {
        containerClassName += " selection";
    }

    return {className, style, containerClassName};
};
